import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useSuperuser() {
  const [isSuperuser, setIsSuperuser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) {
          if (!cancelled) { setIsSuperuser(false); setLoading(false); }
          return;
        }

        const { data } = await supabase
          .from("profiles")
          .select("is_superuser")
          .eq("id", session.user.id)
          .single();

        if (!cancelled) {
          setIsSuperuser(data?.is_superuser === true);
          setLoading(false);
        }
      } catch {
        if (!cancelled) { setIsSuperuser(false); setLoading(false); }
      }
    };

    check();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      check();
    });

    return () => {
      cancelled = true;
      subscription.unsubscribe();
    };
  }, []);

  return { isSuperuser, loading };
}
